import { Calendar } from "@fullcalendar/core";
import { PageBreak, Document, Packer, Paragraph, TextRun, ImageRun, WidthType, TableCell, Table, TableRow, convertInchesToTwip, BorderStyle, Underline } from "docx";
import { saveAs } from "file-saver";
import pdfImage from "../../components/PDF/pdfImage";

export const RPT219WORD = (setLoading, dataReport) => {
    const setValmainInfo = (key) => {
        if (dataReport.mainInfo !== null) {
            return dataReport.mainInfo[key];
        } else {
            return "";
        }
    };
    const setValCase1Report = (key) => {
        if (dataReport.case1Report !== null) {
            return dataReport.case1Report[key];
        } else {
            return "";
        }
    };
    const setValReport2Info = (key) => {
        if (dataReport.report2Info !== null) {
            return dataReport.report2Info[key];
        } else {
            return "";
        }
    };

    const setValCase2Info = (key) => {
        if (dataReport.case2Info !== null) {
            return dataReport.case2Info[key];
        } else {
            return "";
        }
    };

    const setValCase3Info = (key) => {
        if (dataReport.case3Info !== null) {
            return dataReport.case3Info[key];
        } else {
            return "";
        }
    };

    const setValCase4Info = (key) => {
        if (dataReport.case4Info !== null) {
            return dataReport.case4Info[key];
        } else {
            return "";
        }
    };

    const setValCase5Info = (key) => {
        if (dataReport.case5Info !== null) {
            return dataReport.case5Info[key];
        } else {
            return "";
        }
    };

    const cellBorder = {
        noBorderAll: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        borderTop: { bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        borderBottom: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        borderLeft: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        borderRight: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        noBorder: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
    };

    const font = {
        size: {
            xxl: 40,
            xl: 30,
            p: 25,
            tbHeader: 25,
            tbbody: 25,
        },
        SarabunPSK: "TH SarabunPSK",
    };
    const sizeCB = {
        w: 15,
        h: 15,
    };

    const handlerCheck = (key) => {
        return key === "Y" && key !== null ? pdfImage.checkBox : pdfImage.unchecked;
    };
    const handlerCheck_2 = (key, val) => {
        return key === val && key !== null ? pdfImage.checkBox : pdfImage.unchecked;
    };
    const handlerCheckNum = (key, val) => {
        return key === val ? pdfImage.checkBox : pdfImage.unchecked;
    };

    const c1 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        verticalAlign: "center",
                        borders: cellBorder.noBorderAll,
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                verticalAlign: "top",
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: pdfImage.logoPWA_3,
                                                                transformation: {
                                                                    width: 100,
                                                                    height: 100,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                verticalAlign: "center",
                                                width: {
                                                    size: convertInchesToTwip(4),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "ใบรายงานผลปฏิบัติงานประจำวัน/ใบสั่งสนาม ประจำวันที่",
                                                                font: font.SarabunPSK,
                                                                size: font.size.xl,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                verticalAlign: "center",
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.xl,
                                                                text: setValmainInfo("requestDateReport"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c2 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(6),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                margins: { left: convertInchesToTwip(0.1) },
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "สัญญาถูกจ้างเลขที่",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "   " + setValmainInfo("contractNo") + "  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                verticalAlign: "center",
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "เรื่องสัญญาวันที่",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "   " + setValmainInfo("contractBeginDate") + "  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                verticalAlign: "center",
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "สิ้นสุดสัญญาวันที่",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "   " + setValmainInfo("contractEndDate") + "  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ผู้รับจ้าง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "   " + setValmainInfo("contractorName") + "  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                verticalAlign: "center",
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "วงเงินสัญญา",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "   " + setValmainInfo("contractAmount") + "  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        verticalAlign: "center",
                        borders: {
                            bottom: cellBorder.noBorder,
                        },
                        width: {
                            size: convertInchesToTwip(4),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                margins: { left: convertInchesToTwip(0.1) },
                                                verticalAlign: "center",
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "รายชื่อผู้ควบคุมงาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "(1)",
                                                                font: font.SarabunPSK,
                                                            }),

                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "  " + setValmainInfo("supervisorName1") + "   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "(2)",
                                                                font: font.SarabunPSK,
                                                            }),

                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "  " + setValmainInfo("supervisorName2") + "   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c3 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: cellBorder.borderTop,
                        },
                        width: {
                            size: convertInchesToTwip(7),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "สถานที่",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "  " + setValmainInfo("contractLocation") + "   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "แบบแปลนเลขที่",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "  " + setValmainInfo("planNo") + "  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ช่วง กม.",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "  " + setValmainInfo("locationBegin") + "  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "สภาพอากาศ    ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValmainInfo("weather"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " ปกติ    ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValmainInfo("weather"), ""),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " ฝนตก    ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValmainInfo("weather"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " ฝนตกหนัง/มีน้ำท่วมสถานที่ก่อสร้าง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: {
                            top: cellBorder.noBorder,
                        },
                        width: {
                            size: convertInchesToTwip(3),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "(3)",
                                                                font: font.SarabunPSK,
                                                            }),

                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "  " + setValmainInfo("supervisorName3") + "   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.borderTop,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "(1) งานเรียบร้อย",
                                                                font: font.SarabunPSK,
                                                            }),

                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     (2) ควรปรับปรุง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "(3) ไม่ถูกต้อง/ให้แก้ไข",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c4 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: cellBorder.borderTop,
                            right: cellBorder.noBorder,
                        },
                        width: {
                            size: convertInchesToTwip(7),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.การตรวจงานก่อสร้าง    เวลา",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.1 การติดตั้งป้ายประกาศ,ป้ายสัญญาณต่างๆ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.2 การกองท่อและอุปกรณ์ประเภทท่อ บริเวณสถานที่ก่อสร้าง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.3 การตัดแนวคอนกรีต ,เจาะ/ทุบ คอนกรีต",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.4 การขุดแนวร่องดินวาง     ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("topic4Width")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ความกว้าง        ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("topic4Deep")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ความลึก",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.5 วิธีการปฏิบัติงาน วางท่อประปา",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.6 การบดอัดชั้นทราย",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.7 การทดสอบแรงดันในเส้นท่อ ,การฆ่าเชื่อโรค",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.8 การเตรียมความพร้อมการบรรจบท่อเดิมเข้ากับท่อประปาใหม่",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.9 การบรรจบท่อเดิมเข้ากับท่อประปาใหม่ ,การล้างทำความสะอาดท่อประปา",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.10 การบรรจบท่อแยกเข้าบ้าน ,การติดตั้งมาตรวัดน้ำ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "1.11 การซ่อมผิวจราจร และทางเท้า",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: {
                            top: cellBorder.noBorder,
                            left: cellBorder.noBorder,
                        },
                        width: {
                            size: convertInchesToTwip(3),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "(1)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "(2)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "(3)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic1Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic1Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic1Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.07) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic2Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic2Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic2Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.07) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic3Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic3Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic3Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.07) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic4Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic4Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic4Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.07) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic5Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic5Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic5Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.07) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic6Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic6Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic6Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.07) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic7Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic7Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic7Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.07) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic8Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic8Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic8Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.07) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic9Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic9Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic9Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.07) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic10Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic10Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic10Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.07) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic11Result"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic11Result"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase1Report("topic11Result"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c5 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: cellBorder.borderTop,
                        },
                        width: {
                            size: convertInchesToTwip(6),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(4),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ที่       ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("letterNo"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(6),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     วันที่       ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("letterDate"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "เรียน     ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("reportOrderTo"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "2. การสั่งการเฉพาะอย่าง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "2.1  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("specificOrderDetail1"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "2.2  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("specificOrderDetail2"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "2.3  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("specificOrderDetail3"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValReport2Info("guidelineCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เพื่อเป็นแนวทางปฏิบัติตามข้อ    ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValReport2Info("guidelineNo"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValReport2Info("fixExpireCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เพื่อปรับปรุงแก้ไขภายในวันที่    ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValReport2Info("fixExpireDate"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValReport2Info("urgentFixExpireCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เพื่อเร่งดำเนินการโดยด่วย ภายในวันที่    ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValReport2Info("urgentFixExpireDate"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValReport2Info("replyCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     โปรดตอบเป็นหนังสือภายในวันที่    ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValReport2Info("replyExpireDate"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.2) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ให้ตอบกลับพร้อมแนบรูปถ่ายการแก้ไขภายใน วันที่ได้รับใบสั่งสนามฉบับนี้ ทั้งนี้ หากไม่ดำเนินการแก้ไขภายในกำหนด ผู้ควบคุมงานจะสั่งระงับงานก่อสร้างจนกว่าจะแก้ไขแล้วเสร็จ โดยผู้รับจ้างไม่สามารถขอขยายระยะเวลาหรือของด/ลดค่าปรับ จากกรณีนี้ได้",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: {
                            top: cellBorder.noBorder,
                            bottom: cellBorder.noBorder,
                        },
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "4. รายงานผล",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "เรียน     ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("reportResultTo"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "เพื่อโปรดให้ทราบ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.borderBottom,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(1), bottom: convertInchesToTwip(1.5) },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ผู้ควบคุมงาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c6 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: cellBorder.borderTop,
                        },
                        width: {
                            size: convertInchesToTwip(7),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { top: convertInchesToTwip(1), left: convertInchesToTwip(1) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ผู้ควบคุมงาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(3),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- ทราบ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- เรียน ผู้ควบคุมงาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เก็บรวบรวมประกอบการบริหารสัญญา และรายงานคณะกรรมการตรวจรับพัศดุ ดังต่อไปนี้",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c7 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: cellBorder.borderTop,
                        },
                        width: {
                            size: convertInchesToTwip(7),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "3.รายงานผล (สําหรับผู้รับจ้าง)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "เรียน ผู้ควบคุมงาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.7) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ขอรายงานผลตามที่สั่งการข้างตัน ดังนี้",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValReport2Info("fixedCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ปรับปรุง/แก้ไข แล้วเสร็จวันที่      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValReport2Info("fixedDate"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValReport2Info("notDoneCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ไม่สามารถปรับปรุง/แก้ไข ข้อ      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValReport2Info("notDoneNo"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.7) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "เหตุผล      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValReport2Info("notDoneReason"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValReport2Info("notDoneCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ไม่สามารถปรับปรุง/แก้ไข ข้อ      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValReport2Info("notDoneNo"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3), top: convertInchesToTwip(1) },

                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ผู้จัดการสนาม / วิศวกรสนาม",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(3),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- ทราบ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- เรียน ผู้ควบคุมงาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เก็บรวบรวมประกอบการบริหารสัญญา และรายงานคณะกรรมการตรวจรับพัศดุ ดังต่อไปนี้",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.3) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "(......................................)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("signName"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.3) },
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "สำเนา",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.3) },
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "right",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ประธานกรรมการ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1), top: convertInchesToTwip(0.3) },
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.7), top: convertInchesToTwip(0.3), bottom: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "กรรมการ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c8 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            right: cellBorder.noBorder,
                        },
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        columnSpan: 2,
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                bold: true,
                                                                size: font.size.tbbody,
                                                                text: "การตรวจสอบงานตัดบรรจบ (เพิ่มเติม)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        borders: {
                            top: cellBorder.noBorder,
                            bottom: cellBorder.noBorder,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                columnSpan: 2,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ก่อนวันตัดบรรจบ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- ตรวจสอบแนวท่อประปาเดิม   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(8),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValCase2Info("beforeGisCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "GIS      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck(setValCase2Info("beforeAsBuiltCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     As - Built Drawing",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                columnSpan: 2,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ผลการตรวจสอบ     ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase2Info("beforeInspectResult"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " ตรงตามแบบก่อสร้าง     ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase2Info("beforeInspectResult"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " ไม่ตรงตามแบบก่อสร้าง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "-เครื่องสูบน้ำ จำนวน   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValCase2Info("beforePumpCount"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " เครื่อง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase2Info("beforePumpResult"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ถูกต้อง      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("pileInlineResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ถูกต้อง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),

                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        borders: cellBorder.borderRight,
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                columnSpan: 2,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "วันตัดบรรจบ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(4),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "-เครื่องสูบน้ำ จำนวน   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValCase2Info("duringPumpCount"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " เครื่อง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(6),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase2Info("duringPumpResult"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " ใช้งานได้      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase2Info("duringPumpResult"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " ใช้งานไม่ได้",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(6),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "-ป้ายล้อมหลุม จำนวน  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValCase2Info("duringBoundaryFenceCount"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " เครื่อง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(4),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase2Info("duringBoundaryFenceResult"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " ใช้งานได้      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase2Info("duringBoundaryFenceResult"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " ใช้งานไม่ได้",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(4),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(6),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValCase2Info("duringBoundaryFenceResult"), "3"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: " ไม่มี",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(6),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "-รถขุด จำนวน   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValCase2Info("duringBackhoeCount"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     คัน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(6),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "เริ่มเปิดน้ำ เวลา  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValCase2Info("closeValveTime"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เปิดน้ำเวลา    ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValCase2Info("openValveTime"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c9 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            right: cellBorder.noBorder,
                        },
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        columnSpan: 2,
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                bold: true,
                                                                size: font.size.tbbody,
                                                                text: "การตรวจสอบงานโครงสร้าง (แนบสําเนาใบสั่งซื้อประกอบการตรวจสอบ และขอความเห็นชอบจากผู้ควบคุมงาน ให้ใช้งานด้วย)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        borders: {
                            top: cellBorder.noBorder,
                            bottom: cellBorder.noBorder,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                columnSpan: 2,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- เสาเข็ม     ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("pileStandardResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ขนาดตรงตามแบบแปลน/มาตรฐาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                columnSpan: 2,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "             ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("pileStandardResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ขนาดไม่ตรงตามแบบแปลน/มาตรฐาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- การตอกเสาเข็ม",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- แนว",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("pileInlineResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ถูกต้อง      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("pileInlineResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ถูกต้อง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- ระดับ   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("pileLevelResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ถูกต้อง      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("pileLevelResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ถูกต้อง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- ดิ่ง   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("pileVerticalResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ถูกต้อง      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("pileVerticalResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ถูกต้อง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- การเทคอนกรีตโครงสร้าง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- ดิ่ง   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("concreteVerticalResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ถูกต้อง      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("concreteVerticalResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ถูกต้อง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- ถอดแบบตามกำหนด   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("concretePatternResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ถูกต้อง      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("concretePatternResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ถูกต้อง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- บ่มคอนกรีต   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("concreteCuringResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ถูกต้อง      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("concreteCuringResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ถูกต้อง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),

                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        borders: cellBorder.borderRight,
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                columnSpan: 2,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- งานโครงถ้ก (TRUSS)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- เหล็กโครงถัก   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("trussStandardSteelResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ตรงตามแบบ/มาตรฐาน      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("trussStandardSteelResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ตรงตามแบบ/มาตรฐาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- ลวดเชื่อม   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("trussWeldingWireResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ตรงตามแบบ/มาตรฐาน      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("trussWeldingWireResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ตรงตามแบบ/มาตรฐาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- สีรองพื้น (สีเทา)   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("trussPrimerResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ตรงตามแบบ/มาตรฐาน      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("trussPrimerResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ตรงตามแบบ/มาตรฐาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- รอยเชื่อม   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("trussWeldResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ตรงตามแบบ/มาตรฐาน      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase3Info("trussWeldResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ไม่ตรงตามแบบ/มาตรฐาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c10 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            bottom: cellBorder.noBorder,
                        },
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        columnSpan: 2,
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                bold: true,
                                                                size: font.size.tbbody,
                                                                text: "การตรวจสอบงานซ่อมคืนสภาพ   หน่วยงานเจ้าของพื้นที่",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        borders: {
                            top: cellBorder.noBorder,
                            bottom: cellBorder.noBorder,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- การทดสอบวัสดุ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase4Info("testingResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ผ่าน      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase4Info("testingResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    แก้ไข",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- การทดสอบการกดทับวัสดุในสนาม   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase4Info("fieldTestingResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ผ่าน      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase4Info("fieldTestingResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    แก้ไข",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- การแจ้งกำหนดการจัดซ่อม และผลการตรวจของหน่วยงานเจ้าของพื้นที่",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase4Info("scheduleInformResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ตรวจแล้วให้จัดซ่อมได้",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase4Info("scheduleInformResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ตรวจแล้วยังไม่ให้จัดซ่อม",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                columnSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- แจ้งการจัดซ่อมแล้วเสร็จ และผลการตรวจสอบของหน่วยงานเข้าของพื้นที่   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase4Info("feedBackResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ตรวจแล้วผ่าน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },

                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase4Info("feedBackResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    ตรวจแล้วให้แก้ไข",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),

                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },

                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,

                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValCase4Info("repairNote"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c11 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            bottom: cellBorder.noBorder,
                        },
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        columnSpan: 2,
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                bold: true,
                                                                size: font.size.tbbody,
                                                                text: "การตรวจสอบระบบกระปา",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        borders: {
                            top: cellBorder.noBorder,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- ล้างทำความสะอาด (คลอลีนไว้ 24 ชม.)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase5Info("chlorineCleaningResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ผ่าน      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase5Info("chlorineCleaningResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    แก้ไข",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "- แรงดัน 6 กก./ตร.ม.(3 ซม.)   ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase5Info("pressureTesingResult"), "Y"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ผ่าน      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck_2(setValCase5Info("pressureTesingResult"), "N"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "    แก้ไข",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),

                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },

                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(10),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,

                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValCase4Info("inspectNote"),
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c12 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },

                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "บันทึก   แรงงาน และเครื่องจักร",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("engineerCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     วิศวกรสนาม      ",
                                                                font: font.SarabunPSK,
                                                            }),

                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("engineerCount"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     คน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("foremanCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     หัวหน้าคนงาน      ",
                                                                font: font.SarabunPSK,
                                                            }),

                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("foremanCount"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     คน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("pipeFitterCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ช่างประกอบท่อ      ",
                                                                font: font.SarabunPSK,
                                                            }),

                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("pipeFitterCount"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     คน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("workerCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     แรงงาน      ",
                                                                font: font.SarabunPSK,
                                                            }),

                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: setValmainInfo("workerCount"),
                                                                font: font.SarabunPSK,
                                                                underline: { type: "dotted" },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     คน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("truckCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     รถบรรทุก      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("backhoeCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     รถขุดดิน      ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("sandCompactorCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เครื่องบดอัดทราย/ดิน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("pumpCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เครื่องสูบน้ำ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ความสมบูรณ์ของอุปกรณ์",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValmainInfo("pumbStatusCheckbox"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ผ่าน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValmainInfo("pumbStatusCheckbox"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ไม่ผ่าน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ความพร้อมใช้งาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValmainInfo("pumpReadyToUseCheckbox"), "1"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ผ่าน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheckNum(setValmainInfo("pumpReadyToUseCheckbox"), "2"),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ไม่ผ่าน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.5) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("otherCheckbox")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     อื่นๆ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),

                    new TableCell({
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },

                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ควาามเห็น แรงงาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("commentOnWorker")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เพียงพอ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.7) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ไม่พบผู้ปฏิบัติงาน ดังนี้ (แจ้งผู้รับจ้าง)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("commentEngineer")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     วิศวกรสนาม",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("commentForeman")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     หัวหน้าคนงาน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("commentPipeFitter")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     ช่างประกอบท่อ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "เครื่องจักร/เครื่องมือ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(0.3) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("commentTools")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เพียงพอ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "ไม่พบผู้ปฏิบัติงาน ดังนี้ (แจ้งผู้รับจ้าง)",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("commentBackhoe")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     รถขุดดิน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("commentSandCompactor")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เครื่องบดทราย/ดิน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("commentPump")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     เครื่องสูบน้ำ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),

                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                borders: cellBorder.noBorderAll,
                                                margins: { left: convertInchesToTwip(1) },
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(setValmainInfo("commentOther")),
                                                                transformation: {
                                                                    width: sizeCB.w,
                                                                    height: sizeCB.h,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "     อื่นๆ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const brack = new Paragraph({
        children: [new TextRun(""), new PageBreak()],
    });

    const space = new Paragraph({
        children: [],
    });

    const doc = new Document({
        sections: [
            {
                children: [c1, space, c2, c3, c4, c5, brack, c6, c7, brack, c8, c9, c10, c11, brack, c12],
                properties: {
                    page: {
                        margin: {
                            top: convertInchesToTwip(0.5),
                            right: convertInchesToTwip(0.5),
                            bottom: convertInchesToTwip(0.5),
                            left: convertInchesToTwip(0.5),
                        },
                    },
                    type: WidthType.DXA,
                },
            },
        ],
    });

    Packer.toBlob(doc).then((blob) => {
        setLoading(false);
        saveAs(blob, "RPT219.docx");
    });
};
